<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <p>{{data.message}}</p>

</mat-dialog-content>
<mat-dialog-actions>
  @if (!data.hideCancel) {
    <button matButton [mat-dialog-close]="false">Cancel</button>
  }

  <button matButton [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
